import { SofiaChatMessage } from "@/modules/chats/types/chat-message"
import { TranscriptData } from "@/modules/patients/detail/progress-note/types/transcript-message"

export const parseChatTranscript = (chatTranscript: string): SofiaChatMessage[] => {
  const chatMessage: SofiaChatMessage[] = JSON.parse(chatTranscript).map((e: TranscriptData) => {
    let transScriptAcsId: string | null = null

    if (e.sender) {
      transScriptAcsId = e.sender
    } else if (e.content.participants.length === 1) {
      transScriptAcsId = e.content.participants[0].user
    }

    const message: SofiaChatMessage = {
      id: e.id,
      sentAt: new Date(e.createdOn),
      content: e.content.message,
      acsSenderIdentity: transScriptAcsId,
      senderDisplayName: e.senderDisplayName,
      acsChatThreadId: "",
      type: e.type,
      role: "system",
      metadata: e.metadata,
    }
    return message
  })

  return chatMessage
}
